

const ColTwo = ({ children } : { children : JSX.Element }) => {
  return (
    <div className="col-2">{children}</div>
  )
}

export default ColTwo